import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router)

export const router = new Router({
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/login',
      meta: {
        title: 'Login'
      },
      component: () => import(/* webpackChunkName: "login" */ "./views/Login.vue"),
    },
    {
      path: '/profile',
      component: () => import(/* webpackChunkName: "profil" */ "./views/Profil.vue"),
    },
    {
      path: '/Task_1g05h2v/:process/:task',
      component: () => import(/* webpackChunkName: "praxisstruktur" */ "./views/Praxisstruktur.vue"),
    },
    {
      path: '/Task_0mdyaim/:process/:task',
      component: () => import(/* webpackChunkName: "praxisart" */ "./views/Praxisart.vue"),
    },
    {
      path: '/Task_12h92ln/:process/:task',
      component: () => import(/* webpackChunkName: "behandlungsort" */ "./views/Behandlungsort.vue"),
    },
    {
      path: '/Task_12h92lm/:process/:task',
      component: () => import(/* webpackChunkName: "behandlungsortOhneBankdaten" */ "./views/BehandlungsortOhneBankdaten.vue"),
    },
    {
      path: '/Task_1o3bvw4/:process/:task',
      component: () => import(/* webpackChunkName: "arzt" */ "./views/Arzt.vue"),
    },
    {
      path: '/Task_1h5xkzi/:process/:task',
      component: () => import(/* webpackChunkName: "abbrechungsgruppe" */ "./views/Abrechnungsgruppe.vue"),
    },
    {
      path: '/Task_11279nv/:process/:task',
      component: () => import(/* webpackChunkName: "uebersicht" */ "./views/Uebersicht.vue"),
    },
    {
      path: '/Task_0i7mkhz/:process/:task',
      component: () => import(/* webpackChunkName: "asvteam" */ "./views/ASVTeam.vue"),
    },
    {
      path: '/Task_01rcvi0/:process/:task',
      component: () => import(/* webpackChunkName: "bestelldokument" */ "./views/Bestelldokument.vue"),
    },
    {
      path: '/Task_06nnfke/:process/:task',
      component: () => import(/* webpackChunkName: "lizenz" */ "./views/Lizenz.vue"),
    },
    {
      path: '/Task_1xomhzu/:process/:task',
      component: () => import(/* webpackChunkName: "bankdaten" */ "./views/Bankdaten.vue"),
    },
    {
      path: '/Dokument/:process/:task',
      component: () => import(/* webpackChunkName: "dokument" */ "./views/Dokument.vue"),
    }
  ]
})
router.beforeEach((to, from, next) => {
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  if (window.location.href.includes('/#/') && !/Firefox/.test(navigator.userAgent)) {
    window.location.replace(window.location.href.replace('/#/', '/?#/'))
  }
  if (authRequired && !store.getters['authenticated']) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (store.getters['authenticated'] && publicPages.includes(to.path)) {
    next({
      path: '/'
    })
  } else {
    next()
  }
});
